<template>
  <div>
    <!-- 1. 卡片选项区域 (使用 Flex 布局替代 el-row/el-col，完美适配 10 个卡片) -->
    <div class="warning-card-container">
      <div 
        v-for="(label, key) in warningCategories" 
        :key="key"
        class="warning-card-item"
        :class="{ 'active-card': showEarlyWarningType === key }"
        @click="showEarlyWarningType = key"
      >
        <div class="card-label">{{ label }}</div>
        <div class="card-count">
          {{ earlyWarningData[key] ? earlyWarningData[key].length : 0 }}
        </div>
      </div>
    </div>

    <!-- 2. 表格区域 -->
    <el-table :data="earlyWarningData[showEarlyWarningType]" :default-sort="{ prop: 'residenceTime', order: 'descending' }" style="width: 100%; padding: 1em;" v-loading="loading">
      <el-table-column prop="waybillNo" label="运单号">
        <template #default="scope">
          <div style="display: flex; align-items: center;">
            <div @click="waybillQueryPopup({cpCode: scope.row.cpCode, waybillNo: scope.row.waybillNo, phone: ''})"
              style="color: #409EFF; cursor: pointer;">
              {{ scope.row.waybillNo }}
            </div>
            <el-icon v-if="scope.row.waybillNo" @click="common.copy(scope.row.waybillNo)"
              style="margin-left: 0.7em; cursor: pointer;">
              <CopyDocument />
            </el-icon>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="updateDescription" label="最新轨迹" show-overflow-tooltip ></el-table-column>
      <el-table-column prop="uploadTime" label="轨迹更新时间"></el-table-column>
      <el-table-column prop="operatingTime" label="应更新时间"></el-table-column>
      <el-table-column prop="residenceTime" label="超时时长" sortable ></el-table-column>
    </el-table>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        loading: false,
        queryForm: {},
        showEarlyWarningType: "COLLECT",
        warningCategories: {
          "COLLECT": "已揽收",
          "TRANSPORT": "运输中",
          "DELIVERING": "派送中",
          "AGENT": "入库入柜",
          "AGENT_DELIVERING": "驿站代派",
          "FAILED": "签收失败",
          "REJECT": "拒绝签收",
          "SIGN": "已签收",
          "FORWARDING": "转寄中",
          "RETURN": "退回中"
        },
        earlyWarningData: {
          "COLLECT": [], "TRANSPORT": [], "DELIVERING": [], "AGENT": [],
          "AGENT_DELIVERING": [], "FAILED": [], "REJECT": [], "SIGN": [],
          "FORWARDING": [], "RETURN": []
        }
      };
    },
    created() {
      this.get_early_warning_data(this.queryForm);
    },
    methods: {
      get_early_warning_data(queryForm) {
        this.loading = true;
        this.apiService.post({
            modules: "getEarlyWarningList",
            content: queryForm
          })
          .then((res) => {
            if (res.status) {
              if (res.data && res.data.earlyWarningData) {
                this.earlyWarningData = res.data.earlyWarningData;
              }
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  };
</script>

<style scoped>
/* 卡片容器：使用 Flex 布局，自动均分 10 个卡片，间距 12px */
.warning-card-container {
  display: flex;
  gap: 12px; /* 卡片之间的间距 */
  margin-bottom: 16px;
  flex-wrap: nowrap; /* 强制在一行，不换行 */
}

/* 单个卡片基础样式 */
.warning-card-item {
  flex: 1; /* 自动等分宽度 */
  background: #ffffff;
  border: 1px solid #ebeef5;
  border-radius: 8px; /* 增大圆角，更现代 */
  padding: 16px 12px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease; /* 添加平滑过渡动画 */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02); /* 极淡的默认阴影 */
}

/* 鼠标悬停效果 */
.warning-card-item:hover {
  border-color: #c6e2ff;
  background-color: #f9fbff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.06);
  transform: translateY(-2px); /* 微微上浮 */
}

/* 选中状态样式 */
.active-card {
  background: linear-gradient(135deg, #ecf5ff 0%, #d9ecff 100%); /* 柔和的蓝色渐变背景 */
  border-color: #409EFF;
  box-shadow: 0 4px 10px rgba(64, 158, 255, 0.2);
}

/* 文字样式 */
.card-label {
  font-size: 13px;
  color: #606266;
  margin-bottom: 8px;
  white-space: nowrap; /* 防止文字换行 */
}

.card-count {
  font-size: 22px;
  font-weight: 700;
  color: #303133;
  line-height: 1;
}

/* 选中状态下的文字颜色 */
.active-card .card-label,
.active-card .card-count {
  color: #409EFF !important;
}
</style>